export const IMAGES = {
  heroLifestyle:
    "https://images.unsplash.com/photo-1775129667571-7fa3f51c05e3?crop=entropy&cs=srgb&fm=jpg&q=85",
  writingHand:
    "https://images.unsplash.com/photo-1587135991058-8816b028691f?crop=entropy&cs=srgb&fm=jpg&q=85",
  flatlay:
    "https://images.unsplash.com/photo-1456324504439-367cee3b3c32?crop=entropy&cs=srgb&fm=jpg&q=85",
  windowLight:
    "https://images.unsplash.com/photo-1728931709875-b1a9fd14f546?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const HERO = {
  eyebrow: "A patient healthcare journal & organizer",
  lines: ["You deserve to have", "someone in your corner.", "Start with you."],
  sub: "In Your Corner Healthcare is a patient healthcare journal made for real life—the appointments, the medications, the symptoms, the questions you think of on the drive home. Know your health. Know your questions. Know your next step.",
};

export const BENTO_CARDS = [
  { id: "track-health", icon: "clipboard-list", tone: "lav", title: "Track Your Health", body: "Medications, symptoms, and health notes in one place—easy to update, easy to find." },
  { id: "prepare", icon: "calendar-check", tone: "mint", title: "Prepare for Appointments", body: "Walk in with your history, your updates, and your plan—not a scramble to remember." },
  { id: "questions", icon: "help-circle", tone: "blush", title: "Remember Your Questions", body: "Write questions down when they come to you, so nothing gets forgotten at the visit." },
  { id: "next-step", icon: "signpost", tone: "mint", title: "Know Your Next Step", body: "After-visit notes turn doctor's instructions into a clear, simple checklist." },
  { id: "team", icon: "users", tone: "lav", title: "Keep Your Healthcare Team Organized", body: "Every provider, specialty, pharmacy, and phone number—together at last." },
  { id: "follow-ups", icon: "calendar-clock", tone: "blush", title: "Track Follow-Ups & Instructions", body: "Referrals, next appointments, and what to watch for—nothing slips through." },
  { id: "one-place", icon: "notebook", tone: "mint", title: "Keep Everything in One Place", body: "Instead of sticky notes, spreadsheets, and guesswork—one journal that holds it all." },
  { id: "portals", icon: "smartphone", tone: "lav", title: "Works With Your Patient Portal", body: "Complements MyChart and patient portals—paper when you want it, structure when you need it." },
];

export const PAGE_GUIDES = [
  { id: "team", title: "My Healthcare Team", body: "Keep every provider, specialty, and phone number in one place—no more searching through old emails." },
  { id: "questions", title: "Questions for My Doctor", body: "Capture questions the moment they come to you, then bring the list to your next visit." },
  { id: "medications", title: "My Medications", body: "Track each medication, dose, schedule, and what it's for—easy to share with any provider." },
  { id: "appointments", title: "Appointments", body: "Date, time, provider, and reason—your full visit history at a glance." },
  { id: "after-visit", title: "After Visit Notes", body: "Key takeaways, follow-ups, and next steps, written down before they fade." },
  { id: "symptoms", title: "Symptom Tracker", body: "Log symptoms and severity over time, so you can show your doctor patterns instead of guessing." },
  { id: "care-plan", title: "My Care Plan & Goals", body: "Health goals, action steps, what's working, and what's challenging—one clear plan." },
  { id: "contacts", title: "Important Contacts", body: "Emergency contacts and the numbers that matter, right where you can find them." },
  { id: "notes", title: "Notes", body: "Open pages for everything else—because real healthcare doesn't fit in boxes." },
];

export const WHO_HELP = [
  { id: "older-adults", title: "Older adults", body: "Big, easy-to-read pages and simple prompts—no apps to learn, no passwords to remember." },
  { id: "caregivers", title: "Caregivers", body: "Coordinate doctors, medications, and instructions for someone you love—all in one place you can share." },
  { id: "multi-provider", title: "Multiple providers or conditions", body: "When several doctors are involved, this is the one place everything meets." },
  { id: "paper", title: "People who prefer paper", body: "If patient portals feel like a maze, a pen and a clear page might be your favorite upgrade." },
];

export const MARQUEE_ITEMS = [
  "Know your health",
  "Know your questions",
  "Know your next step",
  "Track your health",
  "Prepare for appointments",
  "Stay organized",
];

export const FALLBACK_JOURNAL = {
  slug: "in-your-corner-journal",
  name: "Mini Patient Healthcare Journal",
  tagline: "Know your health. Know your questions. Know your next step.",
  description:
    "In Your Corner Healthcare is a 14-page patient journal that helps you take control of your healthcare—track medications and symptoms, prepare for appointments, write down your questions for the doctor, and keep everything in one place. Fill it in on any device, or print it at home. Prefer paper? A 30-page printed edition is also available on Amazon. Because you deserve to understand your own healthcare.",
  status: "available",
  price_label: "$9.99",
  price_note: "Digital fillable & printable PDF",
  buy_etsy_url: "https://www.etsy.com/listing/4585907434/patient-healthcare-journal-fillable",
  buy_amazon_url: "",
  printed_price_label: "$15.59",
  printed_price_note: "30-page printed journal on Amazon",
  cover_image: "/journal-cover.png",
  who_for: [
    "Anyone managing medications, appointments, or a new diagnosis",
    "People coordinating care for a parent, partner, or child",
    "Patients who think of their questions on the drive home from the appointment",
    "Anyone who wants their health information organized in one place",
  ],
  helps_with: [
    "Track your health",
    "Prepare for appointments",
    "Ask better questions",
    "Stay organized",
    "Take control",
    "Use it on any device—computer, tablet, or phone",
    "Print at home, if you prefer paper",
    "Get it instantly—download right after purchase",
  ],
  format_notes: [
    "Digital edition: 14-page fillable & printable PDF",
    "Printed edition: 30-page journal",
    "Fillable PDF—type directly into the pages",
    "Print at home, if you prefer",
    "Use on any device—computer, tablet, or phone",
    "Instant download after purchase",
  ],
  pages: [
    "My Healthcare Team",
    "Questions for My Doctor",
    "My Medications",
    "Appointments",
    "After Visit Notes",
    "Symptom Tracker",
    "My Care Plan & Goals",
    "Important Contacts",
    "Notes",
  ],
  badges: ["Instant download", "Fillable PDF", "Also in print"],
};

export const AMAZON_NOTE = "The Amazon listing is on the way";

export const MENS_JOURNAL = {
  name: "Men's Edition",
  tagline: "The same journal, dressed in rich burgundy, brown & gold.",
  price_label: "$9.99",
  price_note: "Printable & fillable PDF on Etsy",
  buy_etsy_url: "https://www.etsy.com/listing/4592238714",
  cover_image: "/journal-masculine.png",
};

export const PURSE_EDITION = {
  name: "Purse Edition",
  tagline: "The whole journal, sized to slip into your purse.",
  price_label: "$12.25",
  price_note: "Printed & shipped by Amazon",
  buy_amazon_url: "https://a.co/d/02IFXv9s",
  cover_image: "/journal-purse.png",
};
